import styled from "styled-components";

import { Form } from "antd";

export const LSFormItem = styled(Form.Item)`
    &.secondary {
        .ant-form-item-explain-error {
            color: #fff;
        }
    }

    @media (max-width: 991px) {
        .ant-form-item-label {
            label {
                font-size: 16px;
            }
        }
    }
`;
